import connectCurrentRefinements from "instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements.js";
import { useConnector } from "../hooks/useConnector.js";
export function useCurrentRefinements(props, additionalWidgetProperties) {
  return useConnector(connectCurrentRefinements, props, additionalWidgetProperties);
}